import { formatStringToNumber, parseCartProduct } from './gtmContext.helpers';

export const buildAddCartEvent = (product) => ({
    event: 'eec.addCart',
    ecommerce: {
        add: {
            products: [{
                id:       product.id       || null,
                name:     product.name     || null,
                category: product.category || null,
                variant:  product.variant  || null,
                brand:    product.brand    || null,
                quantity: product.quantity || null,
                price:    formatStringToNumber(product.price),
            }],
        },
    },
});

export const buildImpressionClickEvent = (data) => ({
    event:         'impressionClick',
    eventCallback: data?.product?.href || '',
    ecommerce: {
        click: {
            actionField: { list: data.list },
            products: [{
                id:       data.product.id,
                name:     data.product.name,
                category: data.product.categories,
                position: 1,
            }],
        },
    },
});

export const buildRefundEvent = (order) => ({
    event: 'refund',
    ecommerce: {
        refund: {
            actionField: { id: order.incrementId },
            products: order.items.products.map(p => ({
                id:   p.productId,
                name: p.name,
                qty:  p.qty || 1,
            })),
        },
    },
});

export const buildProductDetailEvent = (data) => {
    const hasSpecialPrice = data.specialPrice &&
        data.specialPrice !== '' &&
        data.specialPrice !== '0,00';

    return {
        event: 'productDetail',
        ecommerce: {
            detail: {
                products: [{
                    id:       data.id       || null,
                    name:     data.name     || null,
                    category: data.category || null,
                    price:    formatStringToNumber(hasSpecialPrice ? data.specialPrice : data.price),
                }],
            },
        },
    };
};

export const buildImpressionViewEvent = (data, list, id) => ({
    event: 'impressionView',
    ecommerce: {
        impressions: data.map((item, index) => ({
            id:       item.id       || null,
            name:     item.name     || null,
            category: item.category || null,
            position: index + 1,
            list,
        })),
    },
    id,
});

export const buildCheckoutEvent = (step, products, callback) => {
    const layer = {
        event: 'checkout',
        ecommerce: {
            checkout: {
                actionField: { step },
                products,
            },
        },
    };

    if (typeof callback === 'function') {
        layer.eventCallback = callback;
    }

    return layer;
};

export const buildCheckoutOptionEvent = (option) => ({
    event: 'checkout_option',
    ecommerce: {
        checkout_option: {
            actionField: {
                step:   3,
                option: option || '',
            },
        },
    },
});

export const buildPurchaseEvent = (payload, products) => ({
    event: 'purchase',
    ecommerce: {
        currencyCode: 'BRL',
        purchase: {
            actionField: {
                id:          payload.incrementId,
                affiliation: 'Sabin',
                value:       formatStringToNumber(payload.total),
                tax:         '0',
                shipping:    payload.shipping,
                coupon:      payload.coupon,
                email:       payload.email || '',
            },
            products,
        },
    },
});
